// 查询计件工资单价-CC列表
import request from '@/utils/request'

// 人员请假录入列表
export async function listEmployeeLeaveCcList (query) {
  return request({
    url: '/bom/bomEmployeeLeaveCc/list',
    method: 'get',
    params: query
  })
}

// 删除人员请假录入
export function apiEmployeeLeaveCcDel (ids) {
  return request({
    url: `/bom/bomEmployeeLeaveCc/${ids}`,
    method: 'delete'
  })
}

// 导出人员请假录入列表
export function apiEmployeeLeaveCcExport (data) {
  return request({
    url: '/bom/bomEmployeeLeaveCc/export',
    method: 'post',
    data: data
  })
}

// 新增或编辑人员请假录入
export function apiEmployeeLeaveCcSaveOrUpdate (data) {
  return request({
    url: '/bom/bomEmployeeLeaveCc/saveOrUpdate',
    method: 'post',
    data: data
  })
}
